import { useRef } from "react";
import { useHistory } from "@/app/hooks/useHistory";
import { OMSButtonStyleL } from "../../../app/common/common-components/OMSButton";
import {
  CONTACT_VIEW_TYPE,
  LABEL,
  LEAD_ACTION_TYPE,
  LEAD_DATE_RANGE_FILTER,
  LEAD_TYPE,
  VIEW,
  VIEW_TYPE,
} from "../constants";
import { OMSDropdown } from "../../../app/common/common-components/OMSDropdown";
import { OMSButtonDropDown2 } from "../../../app/common/common-components/OMSButtonDropDown/OMSButtonDropDown";
import { RadioGroup } from "@/app/common/common-components/ui/RadioGroup";
import { RadioGroupItem } from "@/app/common/common-components/ui/RadioGroup";
import { Label } from "@/app/common/common-components/ui/Label";
import { cn } from "@/app/common/common-functions/functions";
import { Filter, IdCard, LayoutList, List } from "lucide-react";
import { Button } from "@/app/common/common-components/ui/Button";
import MultiTagSelector from "@/app/common/common-components/ui/MultiTagSelector";
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
} from "@/app/common/common-components/ui/HoverCard";

const viewTypeOptions = [
  { Value: VIEW_TYPE.LIST, Text: LABEL.LIST },
  { Value: VIEW_TYPE.CARD_SUMMARY, Text: LABEL.CARD_SUMMARY },
  { Value: VIEW_TYPE.CARD_FULL, Text: LABEL.CARD_FULL },
];
const contactViewTypeOptions = [
  { Value: CONTACT_VIEW_TYPE.MY_CONTACTS, Text: LABEL.MY_CONTACTS },
  { Value: CONTACT_VIEW_TYPE.ALL_CONTACTS, Text: LABEL.ALL_CONTACTS },
];
const leadTypeOptions = [
  { Value: LEAD_TYPE.UN_READ, Text: LABEL.INBOX_UN_READ },
  { Value: LEAD_TYPE.READ, Text: LABEL.INBOX_READ },
  { Value: LEAD_TYPE.ALL, Text: LABEL.INBOX_ALL },
];
const leadLastDaysOptions = [
  { Value: LEAD_DATE_RANGE_FILTER.ALL_LEAD, Text: LABEL.ALL_LEAD },
  { Value: LEAD_DATE_RANGE_FILTER.LAST_30_DAYS, Text: LABEL.LAST_30_DAYS },
  { Value: LEAD_DATE_RANGE_FILTER.LAST_12_MONTH, Text: LABEL.LAST_12_MONTH },
];

const ContactFilter = ({
  actions = [],
  contactType = 0,
  mLeadActionType = LEAD_ACTION_TYPE.NEW,
  mLeadDateRange = 1,
  mLeads = 0,
  mLeadType = LEAD_TYPE.ALL,
  officeTags = [],
  onChangeContactViewType = () => {},
  onChangeLeadActionType = () => {},
  onChangeLeadDateRange = () => {},
  onChangeLeads = () => {},
  onChangeLeadType = () => {},
  onChangeSeachText = () => {},
  onChangeTags = () => {},
  onChangeViewType = () => {},
  searchTerm = "",
  sourceTypesTag = [],
  usersDD = [],
  userTags = [],
  view = VIEW.DEFAULT,
  viewType = 0,
  requirementInfo = {},
  onOpenRequirementFilter = () => {},
}) => {
  const history = useHistory();
  const refSearchBox = useRef();

  const isRequirementApplied =
    (requirementInfo?.SaleType && requirementInfo.SaleType !== "") ||
    (requirementInfo?.PropertyTypes &&
      requirementInfo.PropertyTypes.length > 0) ||
    (requirementInfo?.Areas && requirementInfo.Areas.length > 0) ||
    requirementInfo?.FloorSize > 0 ||
    requirementInfo?.ErfSize > 0 ||
    requirementInfo?.BedRooms > 0 ||
    requirementInfo?.Bathrooms > 0 ||
    requirementInfo?.Garages > 0 ||
    requirementInfo?.Parkings > 0 ||
    requirementInfo?.PriceFrom > 0 ||
    requirementInfo?.PriceTo > 0;

  const handleInputChange = () => {
    const searchText = refSearchBox.current.value;
    onChangeSeachText(searchText);
  };

  const onClickSeachReset = () => {
    onChangeSeachText("");
    refSearchBox.current.focus();
  };

  const handleViewTypeChange = (e) => {
    onChangeViewType(Number(e));
  };

  const handleContactViewTypeChange = (e) => {
    onChangeContactViewType(Number(e.newValue));
  };

  const getLeadDateRangeLabel = () => {
    return mLeadDateRange === 0
      ? LABEL.ALL_LEAD
      : mLeadDateRange === 1
        ? LABEL.LAST_30_DAYS
        : mLeadDateRange === 2
          ? LABEL.LAST_12_MONTH
          : "";
  };

  const handleLeadDateRangeChange = (e) => {
    onChangeLeadDateRange(Number(e));
  };

  const handleTagsChange = (tags) => {
    const selectedTags = tags.filter(
      (tag) => tag.groupId === "officeTags" || tag.groupId === "userTags"
    );
    const selectedSources = tags.filter(
      (tag) => tag.groupId === "sourceTypesTag"
    );
    onChangeTags(
      selectedTags.map((tag) => tag.name),
      selectedSources.map((tag) => tag.name)
    );
  };

  return (
    <>
      <div className="tw-my-4 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-x-2">
        {view !== VIEW.LEAD && (
          <div className="tw-flex tw-min-w-fit tw-flex-1 tw-items-center">
            {/* My Contacts and All Contacts dropdown */}
            <div
              className="contact-view-type-control tw-min-w-fit"
              style={{
                marginRight: "10px",
                marginTop: "7px",
              }}
            >
              <OMSDropdown
                id="ContactViewTypeDD"
                options={contactViewTypeOptions}
                valueField="Value"
                labelField="Text"
                value={contactType}
                onChange={handleContactViewTypeChange}
              />
            </div>

            {/* Requirement filter */}
            <div className="tw-mt-[12px] tw-flex tw-items-center tw-gap-1">
              <Filter className="tw-size-4" />
              <a
                href="#"
                className="filter-text"
                onClick={(e) => {
                  e.preventDefault();
                  onOpenRequirementFilter();
                }}
                style={{
                  whiteSpace: "nowrap",
                  color: isRequirementApplied ? "var(--color2)" : "black",
                  fontWeight: "normal",
                  cursor: "pointer",
                }}
              >
                <span style={{ marginLeft: "2px" }}>
                  Requirements{isRequirementApplied ? " (selected)" : ""}
                </span>
              </a>
            </div>
          </div>
        )}

        <div className="tw-flex tw-flex-1 tw-items-center tw-gap-2">
          {/* Tag filter */}
          {view !== VIEW.LEAD && (
            <MultiTagSelector
              className="tw-mr-2 tw-mt-[7px]"
              tagGroups={[
                {
                  id: "officeTags",
                  name: "Type",
                  tags: officeTags.map((tag) => ({
                    name: tag.name,
                    color: tag.color,
                    groupId: "officeTags",
                  })),
                },
                {
                  id: "userTags",
                  name: "My Tags",
                  tags: userTags.map((tag) => ({
                    name: tag.name,
                    color: tag.color,
                    groupId: "userTags",
                  })),
                },
                {
                  id: "sourceTypesTag",
                  name: "Source",
                  tags: sourceTypesTag.map((tag) => ({
                    name: tag.name,
                    color: tag.color,
                    groupId: "sourceTypesTag",
                  })),
                },
              ]}
              onSelectedTagsChange={handleTagsChange}
            />
          )}

          {/* List, Summary and Full view type dropdown */}
          {view !== VIEW.LEAD && (
            <>
              <div className="tw-flex tw-items-center tw-justify-start tw-gap-1 tw-pt-2">
                {viewTypeOptions.map((item, index) => (
                  <HoverCard key={index}>
                    <HoverCardTrigger asChild>
                      <Button
                        variant={item.Value == viewType ? "default" : "outline"}
                        size="icon"
                        className="tw-flex tw-size-7 tw-cursor-pointer tw-justify-center tw-gap-3"
                        onClick={() => handleViewTypeChange(item.Value)}
                      >
                        {item.Value == VIEW_TYPE.LIST && (
                          <List className="tw-size-4" />
                        )}
                        {item.Value == VIEW_TYPE.CARD_SUMMARY && (
                          <LayoutList className="tw-size-4" />
                        )}
                        {item.Value == VIEW_TYPE.CARD_FULL && (
                          <IdCard className="tw-size-4" />
                        )}
                      </Button>
                    </HoverCardTrigger>
                    <HoverCardContent className="tw-w-fit tw-px-2 tw-py-1 tw-text-xs">
                      {item.Value == VIEW_TYPE.LIST && "List view"}
                      {item.Value == VIEW_TYPE.CARD_SUMMARY && "Summary view"}
                      {item.Value == VIEW_TYPE.CARD_FULL && "Full view"}
                    </HoverCardContent>
                  </HoverCard>
                ))}
              </div>
            </>
          )}

          {/* My Leads dropdown */}
          {view === VIEW.LEAD && (
            <div
              className="contact-lead-control"
              style={{
                marginRight: "10px",
                marginTop: "7px",
                width: "135px",
              }}
            >
              <OMSDropdown
                id="mLeads"
                name="mLeads"
                options={usersDD}
                valueField="value"
                labelField="text"
                value={mLeads}
                onChange={onChangeLeads}
              />
            </div>
          )}

          {/* Lead type dropdown / All, Unread and Read */}
          {view === VIEW.LEAD && (
            <div
              className="contact-lead-type-control"
              style={{
                marginRight: "10px",
                marginTop: "7px",
                width: "135px",
              }}
            >
              <select
                id="mLeadType"
                name="mLeadType"
                style={{
                  width: "auto",
                }}
                value={mLeadType}
                onChange={onChangeLeadType}
                className="form-control"
              >
                {leadTypeOptions.map((item, index) => (
                  <option key={index} value={item.Value}>
                    {item.Text}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

        <div className="tw-flex tw-flex-1 tw-items-center">
          {/* Leads last days dropdown */}
          {view === VIEW.LEAD && (
            <div
              className="view-type-control"
              style={{
                marginTop: "7px",
              }}
            >
              <OMSButtonDropDown2
                label={getLeadDateRangeLabel()}
                currentId={mLeadDateRange}
                dropdownOptions={leadLastDaysOptions}
                onChange={handleLeadDateRangeChange}
              />
            </div>
          )}

          {/* Lead action type dropdown / New and Converted */}
          {view === VIEW.LEAD && (
            <div className="tw-flex tw-flex-row tw-items-center tw-gap-3">
              <div className="lead-action-type-container">
                <input
                  className="cursor-pointer"
                  type="radio"
                  id="rbtnLeadActionTypeNew"
                  name="rbtnLeadActionType"
                  value={LEAD_ACTION_TYPE.NEW}
                  checked={mLeadActionType === LEAD_ACTION_TYPE.NEW}
                  onChange={onChangeLeadActionType}
                />
                <label
                  htmlFor="rbtnLeadActionTypeNew"
                  className="cursor-pointer"
                >
                  New
                </label>
              </div>

              <div className="lead-action-type-container">
                <input
                  className="cursor-pointer"
                  type="radio"
                  id="rbtnLeadActionTypeConverted"
                  name="rbtnLeadActionType"
                  value={LEAD_ACTION_TYPE.CREATE}
                  checked={mLeadActionType === LEAD_ACTION_TYPE.CREATE}
                  onChange={onChangeLeadActionType}
                />
                <label
                  htmlFor="rbtnLeadActionTypeConverted"
                  className="cursor-pointer"
                >
                  Converted
                </label>
              </div>
            </div>
          )}
        </div>

        {/* Search box */}
        <div className="tw-flex tw-items-center tw-justify-center tw-gap-1">
          {
            <div
              className={`${view === VIEW.LEAD ? "search-box-inline-lead" : "search-box-inline-contacts"}`}
              style={{ marginRight: "5px" }}
            >
              <input
                type="text"
                ref={refSearchBox}
                value={searchTerm}
                placeholder="Search..."
                className="search-input-inline"
                onChange={handleInputChange}
              />

              {searchTerm.trim() && (
                <span
                  className="search-button-inline"
                  onClick={() => onClickSeachReset("")}
                >
                  {LABEL.RESET_BTN_TEXT}
                </span>
              )}
            </div>
          }

          {/* Add contact button */}
          {actions.indexOf("create") !== -1 && (
            <div
              className={`${view === VIEW.LEAD ? "add-btn-inline-lead" : "add-btn-inline-contacts"}`}
            >
              <OMSButtonStyleL
                disabled={false}
                onClick={() => history.push("/Contacts/SaveContact")}
                processing={false}
                type="button"
                style={{
                  margin: "",
                }}
                ui_icon=""
                ui_processing_text=""
                ui_text="Add Contact"
                ui_type="create"
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ContactFilter;
